// tgrm-variant-price-fix.js
// Ensures the displayed price updates correctly when a product variant is selected.
// Compatible with Shopify 2.0 themes (Dawn, Gecko/T4S, etc.)

(function() {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updatePrice(variant) {
    if (!variant) return;

    // Update all price elements on the page
    var priceContainers = document.querySelectorAll(
      '[data-product-price], .t4s-price, .price__current, .price-item--regular, .price-item--sale'
    );

    priceContainers.forEach(function(el) {
      var container = el.closest('.t4s-product-price, .price, [data-product-price]');
      if (!container) return;

      // Only update if this is a single-product context (not a grid card)
      if (container.closest('.t4s-product-item:not(.t4s-product-single)')) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        // On sale
        el.innerHTML = '<ins>' + formatMoney(variant.price) + '</ins> <del>' + formatMoney(variant.compare_at_price) + '</del>';
      } else {
        el.innerHTML = formatMoney(variant.price);
      }
    });

    // Also handle the structured price display used by T4S/Gecko themes
    var ins = document.querySelectorAll('[data-product-price] ins, .t4s-product__price ins');
    var del = document.querySelectorAll('[data-product-price] del, .t4s-product__price del');
    if (ins.length || del.length) {
      ins.forEach(function(el) { el.textContent = formatMoney(variant.price); });
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        del.forEach(function(el) { el.textContent = formatMoney(variant.compare_at_price); el.style.display = ''; });
      } else {
        del.forEach(function(el) { el.style.display = 'none'; });
      }
    }
  }

  // Listen for Shopify variant:changed event (fired by theme selectors)
  document.addEventListener('variant:changed', function(evt) {
    if (evt.detail && evt.detail.variant) {
      updatePrice(evt.detail.variant);
    } else if (evt.currentVariant) {
      updatePrice(evt.currentVariant);
    }
  });

  // Also listen for jQuery-style variant:changed (used by T4S theme)
  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).on('variant:changed', function(evt) {
      var v = evt.currentVariant || (evt.detail && evt.detail.variant);
      if (v) updatePrice(v);
    });
  }

  // Fallback: watch the hidden select[name="id"] for changes
  function watchVariantSelect() {
    var selects = document.querySelectorAll('select[name="id"], select[name="items[][id]"]');
    selects.forEach(function(select) {
      if (select._tgrmWatched) return;
      select._tgrmWatched = true;
      select.addEventListener('change', function() {
        var variantId = parseInt(this.value, 10);
        var productData = null;
        try {
          var jsonEl = document.querySelector('.pr_variants_json');
          if (jsonEl) productData = JSON.parse(jsonEl.textContent);
        } catch(e) {}
        if (productData) {
          var variant = productData.find(function(v) { return v.id === variantId; });
          if (variant) updatePrice(variant);
        } else {
          // Fetch from product JSON
          var handle = document.querySelector('[data-product-handle]');
          if (!handle) return;
          fetch('/products/' + handle.dataset.productHandle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(p) {
              var variant = (p.variants || []).find(function(v) { return v.id === variantId; });
              if (variant) updatePrice(variant);
            })
            .catch(function() {});
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', watchVariantSelect);
  setTimeout(watchVariantSelect, 1000);

})();


// TGRM: on carts that carry the in-store bulk-price discount, remove the saved-amount framing:
// the line-item "(-$xxx.xx)" and the subtotal original/savings figures. The struck per-unit price
// on each line still shows the bulk saving; only the aggregate "$xxx off" figure is removed.
// A class on <html> drives CSS so the rule survives the mini-cart's async re-renders.
(function() {
  try {
    var st = document.createElement('style');
    st.textContent = '.tgrm-hide-cart-savings .t4s-cart__originalPrice,.tgrm-hide-cart-savings .t4s-cart__discountPrice{display:none!important;}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  function tgrmCleanBulkDiscount() {
    var els = document.querySelectorAll('li.t4s-order-discount__item');
    var foundBulk = false;
    for (var i = 0; i < els.length; i++) {
      var li = els[i];
      if ((li.textContent || '').toLowerCase().indexOf('bulk') === -1) continue;
      foundBulk = true;
      if (li.getAttribute('data-tgrm-clean')) continue;
      var nodes = li.childNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 3 && /\(-[^)]*\)\s*$/.test(nodes[j].textContent)) {
          nodes[j].textContent = nodes[j].textContent.replace(/\s*\(-[^)]*\)\s*$/, '');
        }
      }
      li.setAttribute('data-tgrm-clean', '1');
    }
    if (foundBulk) { document.documentElement.classList.add('tgrm-hide-cart-savings'); }
  }
  tgrmCleanBulkDiscount();
  document.addEventListener('DOMContentLoaded', tgrmCleanBulkDiscount);
  setTimeout(tgrmCleanBulkDiscount, 400);
  setTimeout(tgrmCleanBulkDiscount, 1200);
  try { new MutationObserver(tgrmCleanBulkDiscount).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();

// TGRM 2026-10-09: mobile cart drawer fix. The Click & Collect / Delivery chooser (tgrm-nav.js)
// sits in the drawer's fixed bottom panel, which made the panel taller than a phone screen and
// pushed View Cart / Check Out out of reach; the green call bar (z-index 10000) also covered the
// bottom 56px. On phones/tablets the whole drawer now scrolls as one page (title pinned), and the
// call bar hides while a drawer is open.
// Also: the red "please choose" gate had display:flex, which overrode its [hidden] attribute,
// so it showed even after Delivery / Click & Collect was selected.
(function() {
  try {
    if (document.getElementById('tgrm-cart-drawer-fix')) return;
    var st = document.createElement('style');
    st.id = 'tgrm-cart-drawer-fix';
    st.textContent =
      '.tgrm-ccp__gate[hidden]{display:none!important;}' +
      '@media (max-width:1024px){' +
        '#t4s-mini_cart.t4s-drawer{height:100%;height:100dvh;overflow-y:auto!important;overflow-x:hidden!important;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;display:block!important;}' +
        '#t4s-mini_cart .t4s-drawer__header{position:sticky;top:0;z-index:6;background:var(--t4s-body-background,#fff);}' +
        '#t4s-mini_cart .t4s-drawer__wrap{display:block!important;height:auto!important;}' +
        '#t4s-mini_cart .t4s-drawer__main{flex:none!important;}' +
        '#t4s-mini_cart .t4s-drawer__main .t4s-drawer__scroll{position:static!important;max-height:none!important;height:auto!important;overflow:visible!important;}' +
        '#t4s-mini_cart .t4s-drawer__bottom{max-height:none!important;overflow:visible!important;padding-bottom:calc(24px + env(safe-area-inset-bottom,0px))!important;}' +
      '}' +
      '@media (max-width:767px){' +
        'html:has(.t4s-drawer[aria-hidden="false"]) .tgrm-call-bar{display:none!important;}' +
        '@supports not selector(:has(*)){#t4s-mini_cart .t4s-drawer__bottom{padding-bottom:76px!important;}}' +
      '}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
})();
